export const ExecuteDrawerConstants = {
    ON_UPDATE_EXECUTE_DRAWER_VISIBILITY: 'DRAWER/ON_UPDATE_EXECUTE_DRAWER_VISIBILITY',
    ON_UPDATE_DRAWER_TAB: 'DRAWER/ON_UPDATE_DRAWER_TAB',
    ON_UPDATE_SELECTED_TAB: 'DRAWER/ON_UPDATE_SELECTED_TAB',
    ON_UPDATE_APPLIED_FILTERS: 'DRAWER/ON_UPDATE_APPLIED_FILTERS',
    ON_RESET_TO_DEFAULT: 'DRAWER/ON_RESET_TO_DEFAULT'
};
